// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AdminRouteImport } from './routes/_admin'
import { Route as AboutRouteImport } from './routes/about'
import { Route as AiNetworkRouteImport } from './routes/ai-network'
import { Route as ApplyRouteImport } from './routes/apply'
import { Route as CertificationsRouteImport } from './routes/certifications'
import { Route as ClientRouteImport } from './routes/client'
import { Route as CommercialRouteImport } from './routes/commercial'
import { Route as ContactRouteImport } from './routes/contact'
import { Route as ContractVehiclesRouteImport } from './routes/contract-vehicles'
import { Route as ContributorsRouteImport } from './routes/contributors'
import { Route as EmailPreferencesRouteImport } from './routes/email-preferences'
import { Route as EmployeeRouteImport } from './routes/employee'
import { Route as GovernmentRouteImport } from './routes/government'
import { Route as HomeRouteImport } from './routes/home'
import { Route as JobsRouteImport } from './routes/jobs'
import { Route as JobsDotxmlRouteImport } from './routes/jobs[.]xml'
import { Route as MemberRouteImport } from './routes/member'
import { Route as NetworkInviteRouteImport } from './routes/network-invite'
import { Route as NewsRouteImport } from './routes/news'
import { Route as PartnerRouteImport } from './routes/partner'
import { Route as PartnerNetworkRouteImport } from './routes/partner-network'
import { Route as PartnershipRouteImport } from './routes/partnership'
import { Route as PrivacyRouteImport } from './routes/privacy'
import { Route as PrivacyPolicyRouteImport } from './routes/privacy-policy'
import { Route as ResetPasswordRouteImport } from './routes/reset-password'
import { Route as ServicesRouteImport } from './routes/services'
import { Route as SignInRouteImport } from './routes/sign-in'
import { Route as SitemapRouteImport } from './routes/sitemap'
import { Route as TalentNetworkRouteImport } from './routes/talent-network'
import { Route as TalentRequestRouteImport } from './routes/talent-request'
import { Route as TermsOfServiceRouteImport } from './routes/terms-of-service'
import { Route as UnsubscribeRouteImport } from './routes/unsubscribe'
import { Route as CareersIndexRouteImport } from './routes/careers/index'
import { Route as CareersCareersRouteImport } from './routes/careers/Careers'
import { Route as ClientSplatRouteImport } from './routes/client/$'
import { Route as ClientContractRouteImport } from './routes/client/contract'
import { Route as ClientDashboardRouteImport } from './routes/client/dashboard'
import { Route as ClientDeliverablesRouteImport } from './routes/client/deliverables'
import { Route as ClientFeedbackRouteImport } from './routes/client/feedback'
import { Route as ClientInvoicesRouteImport } from './routes/client/invoices'
import { Route as ClientKpisRouteImport } from './routes/client/kpis'
import { Route as ClientLoginRouteImport } from './routes/client/login'
import { Route as ClientQaspRouteImport } from './routes/client/qasp'
import { Route as ClientReportsRouteImport } from './routes/client/reports'
import { Route as ClientRequestsRouteImport } from './routes/client/requests'
import { Route as ClientRisksRouteImport } from './routes/client/risks'
import { Route as ClientSettingsRouteImport } from './routes/client/settings'
import { Route as ClientSetupRouteImport } from './routes/client/setup'
import { Route as ClientStaffingRouteImport } from './routes/client/staffing'
import { Route as ClientTimesheetsRouteImport } from './routes/client/timesheets'
import { Route as ClientUpdatesRouteImport } from './routes/client/updates'
import { Route as ClientVacanciesRouteImport } from './routes/client/vacancies'
import { Route as ClientResetPasswordRouteImport } from './routes/client_/reset-password'
import { Route as ContributorDashboardRouteImport } from './routes/contributor/dashboard'
import { Route as ContributorLoginRouteImport } from './routes/contributor/login'
import { Route as ContributorProfileRouteImport } from './routes/contributor/profile'
import { Route as ContributorResetPasswordRouteImport } from './routes/contributor/reset-password'
import { Route as ContributorSetupRouteImport } from './routes/contributor/setup'
import { Route as ContributorSubmitRouteImport } from './routes/contributor/submit'
import { Route as EmployeeSplatRouteImport } from './routes/employee/$'
import { Route as EmployeeDashboardRouteImport } from './routes/employee/dashboard'
import { Route as EmployeeDirectoryRouteImport } from './routes/employee/directory'
import { Route as EmployeeLoginRouteImport } from './routes/employee/login'
import { Route as EmployeePerformanceRouteImport } from './routes/employee/performance'
import { Route as EmployeeProfileRouteImport } from './routes/employee/profile'
import { Route as EmployeeReferralsRouteImport } from './routes/employee/referrals'
import { Route as EmployeeResourcesRouteImport } from './routes/employee/resources'
import { Route as EmployeeSettingsRouteImport } from './routes/employee/settings'
import { Route as EmployeeTimesheetsRouteImport } from './routes/employee/timesheets'
import { Route as EmployeeResetPasswordRouteImport } from './routes/employee_/reset-password'
import { Route as EmployeeSetupPasswordRouteImport } from './routes/employee_/setup-password'
import { Route as Job_categorySplatRouteImport } from './routes/job_category/$'
import { Route as MemberSplatRouteImport } from './routes/member/$'
import { Route as MemberAchievementsRouteImport } from './routes/member/achievements'
import { Route as MemberAdminMessagesRouteImport } from './routes/member/admin-messages'
import { Route as MemberAiToolsRouteImport } from './routes/member/ai-tools'
import { Route as MemberAnnouncementsRouteImport } from './routes/member/announcements'
import { Route as MemberCertificationsRouteImport } from './routes/member/certifications'
import { Route as MemberCommunityPostsRouteImport } from './routes/member/community-posts'
import { Route as MemberContributeRouteImport } from './routes/member/contribute'
import { Route as MemberDashboardRouteImport } from './routes/member/dashboard'
import { Route as MemberDirectoryRouteImport } from './routes/member/directory'
import { Route as MemberEndorsementsRouteImport } from './routes/member/endorsements'
import { Route as MemberEventsRouteImport } from './routes/member/events'
import { Route as MemberLeaderboardRouteImport } from './routes/member/leaderboard'
import { Route as MemberLoginRouteImport } from './routes/member/login'
import { Route as MemberMessagesRouteImport } from './routes/member/messages'
import { Route as MemberOfficeHoursRouteImport } from './routes/member/office-hours'
import { Route as MemberOpportunitiesRouteImport } from './routes/member/opportunities'
import { Route as MemberProfileRouteImport } from './routes/member/profile'
import { Route as MemberPublicationsRouteImport } from './routes/member/publications'
import { Route as MemberResourcesRouteImport } from './routes/member/resources'
import { Route as MemberSettingsRouteImport } from './routes/member/settings'
import { Route as MemberSetupRouteImport } from './routes/member/setup'
import { Route as MemberResetPasswordRouteImport } from './routes/member_/reset-password'
import { Route as NewsletterSplatRouteImport } from './routes/newsletter/$'
import { Route as PartnerIndexRouteImport } from './routes/partner/index'
import { Route as PartnerSplatRouteImport } from './routes/partner/$'
import { Route as PartnerCompanyRouteImport } from './routes/partner/company'
import { Route as PartnerDashboardRouteImport } from './routes/partner/dashboard'
import { Route as PartnerDocumentsRouteImport } from './routes/partner/documents'
import { Route as PartnerPerformanceRouteImport } from './routes/partner/performance'
import { Route as PartnerProfileRouteImport } from './routes/partner/profile'
import { Route as PartnerSettingsRouteImport } from './routes/partner/settings'
import { Route as PartnerSubmissionsRouteImport } from './routes/partner/submissions'
import { Route as PartnerWorkRouteImport } from './routes/partner/work'
import { Route as PartnerActivateRouteImport } from './routes/partner_/activate'
import { Route as PartnerResetPasswordRouteImport } from './routes/partner_/reset-password'
import { Route as PartnerSetupRouteImport } from './routes/partner_/setup'
import { Route as ProductsIndexRouteImport } from './routes/products/index'
import { Route as ProductsAgenticEnterprisePlatformRouteImport } from './routes/products/agentic-enterprise-platform'
import { Route as ProductsAkivaInceptionRouteImport } from './routes/products/akiva-inception'
import { Route as ProductsBiosRouteImport } from './routes/products/bios'
import { Route as ProductsComputeRouteImport } from './routes/products/compute'
import { Route as ProductsDatasyncEnterpriseRouteImport } from './routes/products/datasync-enterprise'
import { Route as ProductsDecisionSupportRouteImport } from './routes/products/decision-support'
import { Route as ProductsHardwareRouteImport } from './routes/products/hardware'
import { Route as ProductsInceptionRouteImport } from './routes/products/inception'
import { Route as ProductsMarketinsightProRouteImport } from './routes/products/marketinsight-pro'
import { Route as ProductsModelopsProRouteImport } from './routes/products/modelops-pro'
import { Route as ProductsNovaEnterpriseRouteImport } from './routes/products/nova-enterprise'
import { Route as ProductsNovaHealthcareRouteImport } from './routes/products/nova-healthcare'
import { Route as ProductsNovaWorkspaceRouteImport } from './routes/products/nova-workspace'
import { Route as ProductsPerformancevisionProRouteImport } from './routes/products/performancevision-pro'
import { Route as ProductsSmartsourceProRouteImport } from './routes/products/smartsource-pro'
import { Route as ProductsSoftwareRouteImport } from './routes/products/software'
import { Route as ServiceAiEngineeringRouteImport } from './routes/service/ai-engineering'
import { Route as ServiceAiIntegrationRouteImport } from './routes/service/ai-integration'
import { Route as ServiceAiSecurityRouteImport } from './routes/service/ai-security'
import { Route as ServiceAiStrategyRouteImport } from './routes/service/ai-strategy'
import { Route as ServiceComputerVisionRouteImport } from './routes/service/computer-vision'
import { Route as ServiceCybersecurityRouteImport } from './routes/service/cybersecurity'
import { Route as ServiceDataEngineeringRouteImport } from './routes/service/data-engineering'
import { Route as ServiceDigitalTransformationRouteImport } from './routes/service/digital-transformation'
import { Route as ServiceEnterpriseItRouteImport } from './routes/service/enterprise-it'
import { Route as ServiceMlopsRouteImport } from './routes/service/mlops'
import { Route as ServiceMultiAgentSystemsRouteImport } from './routes/service/multi-agent-systems'
import { Route as ServiceProgramManagementRouteImport } from './routes/service/program-management'
import { Route as ServiceStrategyConsultingRouteImport } from './routes/service/strategy-consulting'
import { Route as ServiceSupplyChainRouteImport } from './routes/service/supply-chain'
import { Route as SurveyTokenRouteImport } from './routes/survey/$token'
import { Route as WpAdminSplatRouteImport } from './routes/wp-admin/$'
import { Route as WpContentSplatRouteImport } from './routes/wp-content/$'
import { Route as AdminAdminIndexRouteImport } from './routes/_admin/admin/index'
import { Route as AdminAdminAccountsRouteImport } from './routes/_admin/admin/accounts'
import { Route as AdminAdminAchievementsRouteImport } from './routes/_admin/admin/achievements'
import { Route as AdminAdminAiToolSuggestionsRouteImport } from './routes/_admin/admin/ai-tool-suggestions'
import { Route as AdminAdminAnnouncementsRouteImport } from './routes/_admin/admin/announcements'
import { Route as AdminAdminApiDocsRouteImport } from './routes/_admin/admin/api-docs'
import { Route as AdminAdminAuditLogsRouteImport } from './routes/_admin/admin/audit-logs'
import { Route as AdminAdminCandidatePipelineRouteImport } from './routes/_admin/admin/candidate-pipeline'
import { Route as AdminAdminCareersRouteImport } from './routes/_admin/admin/careers'
import { Route as AdminAdminCareersProfileRouteImport } from './routes/_admin/admin/careers-profile'
import { Route as AdminAdminClientAccountsRouteImport } from './routes/_admin/admin/client-accounts'
import { Route as AdminAdminClientContactsRouteImport } from './routes/_admin/admin/client-contacts'
import { Route as AdminAdminClientFeedbackRouteImport } from './routes/_admin/admin/client-feedback'
import { Route as AdminAdminCommunityProgramsRouteImport } from './routes/_admin/admin/community-programs'
import { Route as AdminAdminContactInquiriesRouteImport } from './routes/_admin/admin/contact-inquiries'
import { Route as AdminAdminContentRouteImport } from './routes/_admin/admin/content'
import { Route as AdminAdminCrossModuleReportRouteImport } from './routes/_admin/admin/cross-module-report'
import { Route as AdminAdminDigestPreviewRouteImport } from './routes/_admin/admin/digest-preview'
import { Route as AdminAdminDocumentIntakeRouteImport } from './routes/_admin/admin/document-intake'
import { Route as AdminAdminEmailGalleryRouteImport } from './routes/_admin/admin/email-gallery'
import { Route as AdminAdminEmailSchedulerRouteImport } from './routes/_admin/admin/email-scheduler'
import { Route as AdminAdminEmailTemplatesRouteImport } from './routes/_admin/admin/email-templates'
import { Route as AdminAdminEmployeesRouteImport } from './routes/_admin/admin/employees'
import { Route as AdminAdminEventsRouteImport } from './routes/_admin/admin/events'
import { Route as AdminAdminExecDashboardRouteImport } from './routes/_admin/admin/exec-dashboard'
import { Route as AdminAdminExternalToolsRouteImport } from './routes/_admin/admin/external-tools'
import { Route as AdminAdminForumModerationRouteImport } from './routes/_admin/admin/forum-moderation'
import { Route as AdminAdminFundingTrackerRouteImport } from './routes/_admin/admin/funding-tracker'
import { Route as AdminAdminInboundEmailRouteImport } from './routes/_admin/admin/inbound-email'
import { Route as AdminAdminInterviewSlotsRouteImport } from './routes/_admin/admin/interview-slots'
import { Route as AdminAdminInvitationAnalyticsRouteImport } from './routes/_admin/admin/invitation-analytics'
import { Route as AdminAdminInvoicesRouteImport } from './routes/_admin/admin/invoices'
import { Route as AdminAdminJobBoardsRouteImport } from './routes/_admin/admin/job-boards'
import { Route as AdminAdminJobSyndicationRouteImport } from './routes/_admin/admin/job-syndication'
import { Route as AdminAdminLaborCategoriesRouteImport } from './routes/_admin/admin/labor-categories'
import { Route as AdminAdminLoginRouteImport } from './routes/_admin/admin/login'
import { Route as AdminAdminMemberInboxRouteImport } from './routes/_admin/admin/member-inbox'
import { Route as AdminAdminMfaResetRouteImport } from './routes/_admin/admin/mfa-reset'
import { Route as AdminAdminNetworkAnnouncementsRouteImport } from './routes/_admin/admin/network-announcements'
import { Route as AdminAdminNewsletterRouteImport } from './routes/_admin/admin/newsletter'
import { Route as AdminAdminOperationsRouteImport } from './routes/_admin/admin/operations'
import { Route as AdminAdminOptionCalendarRouteImport } from './routes/_admin/admin/option-calendar'
import { Route as AdminAdminOrganizationsRouteImport } from './routes/_admin/admin/organizations'
import { Route as AdminAdminPartnerAccountsRouteImport } from './routes/_admin/admin/partner-accounts'
import { Route as AdminAdminPartnersRouteImport } from './routes/_admin/admin/partners'
import { Route as AdminAdminPerformanceKpiRouteImport } from './routes/_admin/admin/performance-kpi'
import { Route as AdminAdminPlatformEventsRouteImport } from './routes/_admin/admin/platform-events'
import { Route as AdminAdminProjectEvmRouteImport } from './routes/_admin/admin/project-evm'
import { Route as AdminAdminProjectInterestsRouteImport } from './routes/_admin/admin/project-interests'
import { Route as AdminAdminProjectReportingRouteImport } from './routes/_admin/admin/project-reporting'
import { Route as AdminAdminProjectsRouteImport } from './routes/_admin/admin/projects'
import { Route as AdminAdminQualityDeliverablesRouteImport } from './routes/_admin/admin/quality-deliverables'
import { Route as AdminAdminQualityMetricsRouteImport } from './routes/_admin/admin/quality-metrics'
import { Route as AdminAdminQuickLinksRouteImport } from './routes/_admin/admin/quick-links'
import { Route as AdminAdminReferralsRouteImport } from './routes/_admin/admin/referrals'
import { Route as AdminAdminResetPasswordRouteImport } from './routes/_admin/admin/reset-password'
import { Route as AdminAdminResourceSuggestionsRouteImport } from './routes/_admin/admin/resource-suggestions'
import { Route as AdminAdminResourcesRouteImport } from './routes/_admin/admin/resources'
import { Route as AdminAdminRiskComplianceRouteImport } from './routes/_admin/admin/risk-compliance'
import { Route as AdminAdminSecurityRouteImport } from './routes/_admin/admin/security'
import { Route as AdminAdminStaffingAssignmentsRouteImport } from './routes/_admin/admin/staffing-assignments'
import { Route as AdminAdminStaffingComplianceRouteImport } from './routes/_admin/admin/staffing-compliance'
import { Route as AdminAdminTalentRouteImport } from './routes/_admin/admin/talent'
import { Route as AdminAdminTalentDirectoryRouteImport } from './routes/_admin/admin/talent-directory'
import { Route as AdminAdminTalentRequestsRouteImport } from './routes/_admin/admin/talent-requests'
import { Route as AdminAdminTalentSearchRouteImport } from './routes/_admin/admin/talent-search'
import { Route as AdminAdminTaskOrdersRouteImport } from './routes/_admin/admin/task-orders'
import { Route as AdminAdminTimesheetsRouteImport } from './routes/_admin/admin/timesheets'
import { Route as AdminAdminUserManagementRouteImport } from './routes/_admin/admin/user-management'
import { Route as AdminAdminVacancyForecastRouteImport } from './routes/_admin/admin/vacancy-forecast'
import { Route as AdminAdminVisitorAnalyticsRouteImport } from './routes/_admin/admin/visitor-analytics'
import { Route as CareersJobsIndexRouteImport } from './routes/careers/jobs/index'
import { Route as CareersResumeReuploadTokenRouteImport } from './routes/careers/resume-reupload/$token'
import { Route as ClientInviteActivateRouteImport } from './routes/client_/invite/activate'
import { Route as CompanyPressIndexRouteImport } from './routes/company/press/index'
import { Route as CompanyPressSplatRouteImport } from './routes/company/press/$'
import { Route as MemberAuthCallbackRouteImport } from './routes/member/auth/callback'
import { Route as MemberForumsIndexRouteImport } from './routes/member/forums/index'
import { Route as MemberForumsNewRouteImport } from './routes/member/forums/new'
import { Route as MemberMentorshipIndexRouteImport } from './routes/member/mentorship/index'
import { Route as MemberMentorshipDashboardRouteImport } from './routes/member/mentorship/dashboard'
import { Route as MemberProjectsIndexRouteImport } from './routes/member/projects/index'
import { Route as MemberProjectsIdRouteImport } from './routes/member/projects/$id'
import { Route as MemberInviteActivateRouteImport } from './routes/member_/invite/activate'
import { Route as ProductsChatspaceSplatRouteImport } from './routes/products/chatspace/$'
import { Route as ProductsMindcruiserSplatRouteImport } from './routes/products/mindcruiser/$'
import { Route as ProductsWebboardSplatRouteImport } from './routes/products/webboard/$'
import { Route as AdminAdminClientsIndexRouteImport } from './routes/_admin/admin/clients/index'
import { Route as AdminAdminClientsIdRouteImport } from './routes/_admin/admin/clients/$id'
import { Route as AdminAdminContractsIndexRouteImport } from './routes/_admin/admin/contracts/index'
import { Route as AdminAdminContractsIdRouteImport } from './routes/_admin/admin/contracts/$id'
import { Route as AdminAdminPerformanceActionsRouteImport } from './routes/_admin/admin/performance/actions'
import { Route as AdminAdminPerformanceAiSuggestionsRouteImport } from './routes/_admin/admin/performance/ai-suggestions'
import { Route as AdminAdminPerformanceGoalProposalsRouteImport } from './routes/_admin/admin/performance/goal-proposals'
import { Route as AdminAdminPerformanceResourcesRouteImport } from './routes/_admin/admin/performance/resources'
import { Route as AdminAdminPerformanceTeamPulseRouteImport } from './routes/_admin/admin/performance/team-pulse'
import { Route as AdminAdminPerformanceTriageRouteImport } from './routes/_admin/admin/performance/triage'
import { Route as AdminAdminRequisitionsIndexRouteImport } from './routes/_admin/admin/requisitions/index'
import { Route as AdminAdminRequisitionsIdRouteImport } from './routes/_admin/admin/requisitions/$id'
import { Route as AdminAdminSubcontractorsIndexRouteImport } from './routes/_admin/admin/subcontractors/index'
import { Route as AdminAdminSubcontractorsIdRouteImport } from './routes/_admin/admin/subcontractors/$id'
import { Route as CareersJobsSlugIndexRouteImport } from './routes/careers/jobs/$slug/index'
import { Route as CareersJobsSlugApplyRouteImport } from './routes/careers/jobs/$slug/apply'
import { Route as ClientContractsContractIdIndexRouteImport } from './routes/client/contracts/$contractId/index'
import { Route as ClientContractsContractIdInvoicesRouteImport } from './routes/client/contracts/$contractId/invoices'
import { Route as ClientContractsContractIdKpisRouteImport } from './routes/client/contracts/$contractId/kpis'
import { Route as ClientContractsContractIdQaspRouteImport } from './routes/client/contracts/$contractId/qasp'
import { Route as ClientContractsContractIdReportsRouteImport } from './routes/client/contracts/$contractId/reports'
import { Route as ClientContractsContractIdRequestsRouteImport } from './routes/client/contracts/$contractId/requests'
import { Route as ClientContractsContractIdRisksRouteImport } from './routes/client/contracts/$contractId/risks'
import { Route as ClientContractsContractIdStaffingRouteImport } from './routes/client/contracts/$contractId/staffing'
import { Route as ClientContractsContractIdTimesheetsRouteImport } from './routes/client/contracts/$contractId/timesheets'
import { Route as ClientContractsContractIdVacanciesRouteImport } from './routes/client/contracts/$contractId/vacancies'
import { Route as MemberForumsThreadThreadIdRouteImport } from './routes/member/forums/thread/$threadId'
import { Route as AdminAdminPerformanceCyclesIndexRouteImport } from './routes/_admin/admin/performance/cycles/index'
import { Route as AdminAdminPerformanceCyclesIdRouteImport } from './routes/_admin/admin/performance/cycles/$id'
import { Route as AdminAdminPerformanceEmployeesIndexRouteImport } from './routes/_admin/admin/performance/employees/index'
import { Route as AdminAdminPerformanceEmployeesIdRouteImport } from './routes/_admin/admin/performance/employees/$id'
import { Route as AdminAdminPerformancePipIndexRouteImport } from './routes/_admin/admin/performance/pip/index'
import { Route as AdminAdminPerformancePipPipIdRouteImport } from './routes/_admin/admin/performance/pip/$pipId'
import { Route as AdminAdminPerformancePipNewRouteImport } from './routes/_admin/admin/performance/pip/new'
import { Route as ClientContractsContractIdDeliverablesIndexRouteImport } from './routes/client/contracts/$contractId/deliverables/index'
import { Route as ClientContractsContractIdDeliverablesDeliverableIdRouteImport } from './routes/client/contracts/$contractId/deliverables/$deliverableId'

const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const AdminRoute = AdminRouteImport.update({
            id: '/_admin',getParentRoute: () => rootRouteImport
          })
const AboutRoute = AboutRouteImport.update({
            id: '/about',path: '/about',getParentRoute: () => rootRouteImport
          })
const AiNetworkRoute = AiNetworkRouteImport.update({
            id: '/ai-network',path: '/ai-network',getParentRoute: () => rootRouteImport
          })
const ApplyRoute = ApplyRouteImport.update({
            id: '/apply',path: '/apply',getParentRoute: () => rootRouteImport
          })
const CertificationsRoute = CertificationsRouteImport.update({
            id: '/certifications',path: '/certifications',getParentRoute: () => rootRouteImport
          })
const ClientRoute = ClientRouteImport.update({
            id: '/client',path: '/client',getParentRoute: () => rootRouteImport
          })
const CommercialRoute = CommercialRouteImport.update({
            id: '/commercial',path: '/commercial',getParentRoute: () => rootRouteImport
          })
const ContactRoute = ContactRouteImport.update({
            id: '/contact',path: '/contact',getParentRoute: () => rootRouteImport
          })
const ContractVehiclesRoute = ContractVehiclesRouteImport.update({
            id: '/contract-vehicles',path: '/contract-vehicles',getParentRoute: () => rootRouteImport
          })
const ContributorsRoute = ContributorsRouteImport.update({
            id: '/contributors',path: '/contributors',getParentRoute: () => rootRouteImport
          })
const EmailPreferencesRoute = EmailPreferencesRouteImport.update({
            id: '/email-preferences',path: '/email-preferences',getParentRoute: () => rootRouteImport
          })
const EmployeeRoute = EmployeeRouteImport.update({
            id: '/employee',path: '/employee',getParentRoute: () => rootRouteImport
          })
const GovernmentRoute = GovernmentRouteImport.update({
            id: '/government',path: '/government',getParentRoute: () => rootRouteImport
          })
const HomeRoute = HomeRouteImport.update({
            id: '/home',path: '/home',getParentRoute: () => rootRouteImport
          })
const JobsRoute = JobsRouteImport.update({
            id: '/jobs',path: '/jobs',getParentRoute: () => rootRouteImport
          })
const JobsDotxmlRoute = JobsDotxmlRouteImport.update({
            id: '/jobs.xml',path: '/jobs.xml',getParentRoute: () => rootRouteImport
          })
const MemberRoute = MemberRouteImport.update({
            id: '/member',path: '/member',getParentRoute: () => rootRouteImport
          })
const NetworkInviteRoute = NetworkInviteRouteImport.update({
            id: '/network-invite',path: '/network-invite',getParentRoute: () => rootRouteImport
          })
const NewsRoute = NewsRouteImport.update({
            id: '/news',path: '/news',getParentRoute: () => rootRouteImport
          })
const PartnerRoute = PartnerRouteImport.update({
            id: '/partner',path: '/partner',getParentRoute: () => rootRouteImport
          })
const PartnerNetworkRoute = PartnerNetworkRouteImport.update({
            id: '/partner-network',path: '/partner-network',getParentRoute: () => rootRouteImport
          })
const PartnershipRoute = PartnershipRouteImport.update({
            id: '/partnership',path: '/partnership',getParentRoute: () => rootRouteImport
          })
const PrivacyRoute = PrivacyRouteImport.update({
            id: '/privacy',path: '/privacy',getParentRoute: () => rootRouteImport
          })
const PrivacyPolicyRoute = PrivacyPolicyRouteImport.update({
            id: '/privacy-policy',path: '/privacy-policy',getParentRoute: () => rootRouteImport
          })
const ResetPasswordRoute = ResetPasswordRouteImport.update({
            id: '/reset-password',path: '/reset-password',getParentRoute: () => rootRouteImport
          })
const ServicesRoute = ServicesRouteImport.update({
            id: '/services',path: '/services',getParentRoute: () => rootRouteImport
          })
const SignInRoute = SignInRouteImport.update({
            id: '/sign-in',path: '/sign-in',getParentRoute: () => rootRouteImport
          })
const SitemapRoute = SitemapRouteImport.update({
            id: '/sitemap',path: '/sitemap',getParentRoute: () => rootRouteImport
          })
const TalentNetworkRoute = TalentNetworkRouteImport.update({
            id: '/talent-network',path: '/talent-network',getParentRoute: () => rootRouteImport
          })
const TalentRequestRoute = TalentRequestRouteImport.update({
            id: '/talent-request',path: '/talent-request',getParentRoute: () => rootRouteImport
          })
const TermsOfServiceRoute = TermsOfServiceRouteImport.update({
            id: '/terms-of-service',path: '/terms-of-service',getParentRoute: () => rootRouteImport
          })
const UnsubscribeRoute = UnsubscribeRouteImport.update({
            id: '/unsubscribe',path: '/unsubscribe',getParentRoute: () => rootRouteImport
          })
const CareersIndexRoute = CareersIndexRouteImport.update({
            id: '/careers/',path: '/careers/',getParentRoute: () => rootRouteImport
          })
const CareersCareersRoute = CareersCareersRouteImport.update({
            id: '/careers/Careers',path: '/careers/Careers',getParentRoute: () => rootRouteImport
          })
const ClientSplatRoute = ClientSplatRouteImport.update({
            id: '/$',path: '/$',getParentRoute: () => ClientRoute
          })
const ClientContractRoute = ClientContractRouteImport.update({
            id: '/contract',path: '/contract',getParentRoute: () => ClientRoute
          })
const ClientDashboardRoute = ClientDashboardRouteImport.update({
            id: '/dashboard',path: '/dashboard',getParentRoute: () => ClientRoute
          })
const ClientDeliverablesRoute = ClientDeliverablesRouteImport.update({
            id: '/deliverables',path: '/deliverables',getParentRoute: () => ClientRoute
          })
const ClientFeedbackRoute = ClientFeedbackRouteImport.update({
            id: '/feedback',path: '/feedback',getParentRoute: () => ClientRoute
          })
const ClientInvoicesRoute = ClientInvoicesRouteImport.update({
            id: '/invoices',path: '/invoices',getParentRoute: () => ClientRoute
          })
const ClientKpisRoute = ClientKpisRouteImport.update({
            id: '/kpis',path: '/kpis',getParentRoute: () => ClientRoute
          })
const ClientLoginRoute = ClientLoginRouteImport.update({
            id: '/login',path: '/login',getParentRoute: () => ClientRoute
          })
const ClientQaspRoute = ClientQaspRouteImport.update({
            id: '/qasp',path: '/qasp',getParentRoute: () => ClientRoute
          })
const ClientReportsRoute = ClientReportsRouteImport.update({
            id: '/reports',path: '/reports',getParentRoute: () => ClientRoute
          })
const ClientRequestsRoute = ClientRequestsRouteImport.update({
            id: '/requests',path: '/requests',getParentRoute: () => ClientRoute
          })
const ClientRisksRoute = ClientRisksRouteImport.update({
            id: '/risks',path: '/risks',getParentRoute: () => ClientRoute
          })
const ClientSettingsRoute = ClientSettingsRouteImport.update({
            id: '/settings',path: '/settings',getParentRoute: () => ClientRoute
          })
const ClientSetupRoute = ClientSetupRouteImport.update({
            id: '/setup',path: '/setup',getParentRoute: () => ClientRoute
          })
const ClientStaffingRoute = ClientStaffingRouteImport.update({
            id: '/staffing',path: '/staffing',getParentRoute: () => ClientRoute
          })
const ClientTimesheetsRoute = ClientTimesheetsRouteImport.update({
            id: '/timesheets',path: '/timesheets',getParentRoute: () => ClientRoute
          })
const ClientUpdatesRoute = ClientUpdatesRouteImport.update({
            id: '/updates',path: '/updates',getParentRoute: () => ClientRoute
          })
const ClientVacanciesRoute = ClientVacanciesRouteImport.update({
            id: '/vacancies',path: '/vacancies',getParentRoute: () => ClientRoute
          })
const ClientResetPasswordRoute = ClientResetPasswordRouteImport.update({
            id: '/client_/reset-password',path: '/client/reset-password',getParentRoute: () => rootRouteImport
          })
const ContributorDashboardRoute = ContributorDashboardRouteImport.update({
            id: '/contributor/dashboard',path: '/contributor/dashboard',getParentRoute: () => rootRouteImport
          })
const ContributorLoginRoute = ContributorLoginRouteImport.update({
            id: '/contributor/login',path: '/contributor/login',getParentRoute: () => rootRouteImport
          })
const ContributorProfileRoute = ContributorProfileRouteImport.update({
            id: '/contributor/profile',path: '/contributor/profile',getParentRoute: () => rootRouteImport
          })
const ContributorResetPasswordRoute = ContributorResetPasswordRouteImport.update({
            id: '/contributor/reset-password',path: '/contributor/reset-password',getParentRoute: () => rootRouteImport
          })
const ContributorSetupRoute = ContributorSetupRouteImport.update({
            id: '/contributor/setup',path: '/contributor/setup',getParentRoute: () => rootRouteImport
          })
const ContributorSubmitRoute = ContributorSubmitRouteImport.update({
            id: '/contributor/submit',path: '/contributor/submit',getParentRoute: () => rootRouteImport
          })
const EmployeeSplatRoute = EmployeeSplatRouteImport.update({
            id: '/$',path: '/$',getParentRoute: () => EmployeeRoute
          })
const EmployeeDashboardRoute = EmployeeDashboardRouteImport.update({
            id: '/dashboard',path: '/dashboard',getParentRoute: () => EmployeeRoute
          })
const EmployeeDirectoryRoute = EmployeeDirectoryRouteImport.update({
            id: '/directory',path: '/directory',getParentRoute: () => EmployeeRoute
          })
const EmployeeLoginRoute = EmployeeLoginRouteImport.update({
            id: '/login',path: '/login',getParentRoute: () => EmployeeRoute
          })
const EmployeePerformanceRoute = EmployeePerformanceRouteImport.update({
            id: '/performance',path: '/performance',getParentRoute: () => EmployeeRoute
          })
const EmployeeProfileRoute = EmployeeProfileRouteImport.update({
            id: '/profile',path: '/profile',getParentRoute: () => EmployeeRoute
          })
const EmployeeReferralsRoute = EmployeeReferralsRouteImport.update({
            id: '/referrals',path: '/referrals',getParentRoute: () => EmployeeRoute
          })
const EmployeeResourcesRoute = EmployeeResourcesRouteImport.update({
            id: '/resources',path: '/resources',getParentRoute: () => EmployeeRoute
          })
const EmployeeSettingsRoute = EmployeeSettingsRouteImport.update({
            id: '/settings',path: '/settings',getParentRoute: () => EmployeeRoute
          })
const EmployeeTimesheetsRoute = EmployeeTimesheetsRouteImport.update({
            id: '/timesheets',path: '/timesheets',getParentRoute: () => EmployeeRoute
          })
const EmployeeResetPasswordRoute = EmployeeResetPasswordRouteImport.update({
            id: '/employee_/reset-password',path: '/employee/reset-password',getParentRoute: () => rootRouteImport
          })
const EmployeeSetupPasswordRoute = EmployeeSetupPasswordRouteImport.update({
            id: '/employee_/setup-password',path: '/employee/setup-password',getParentRoute: () => rootRouteImport
          })
const Job_categorySplatRoute = Job_categorySplatRouteImport.update({
            id: '/job_category/$',path: '/job_category/$',getParentRoute: () => rootRouteImport
          })
const MemberSplatRoute = MemberSplatRouteImport.update({
            id: '/$',path: '/$',getParentRoute: () => MemberRoute
          })
const MemberAchievementsRoute = MemberAchievementsRouteImport.update({
            id: '/achievements',path: '/achievements',getParentRoute: () => MemberRoute
          })
const MemberAdminMessagesRoute = MemberAdminMessagesRouteImport.update({
            id: '/admin-messages',path: '/admin-messages',getParentRoute: () => MemberRoute
          })
const MemberAiToolsRoute = MemberAiToolsRouteImport.update({
            id: '/ai-tools',path: '/ai-tools',getParentRoute: () => MemberRoute
          })
const MemberAnnouncementsRoute = MemberAnnouncementsRouteImport.update({
            id: '/announcements',path: '/announcements',getParentRoute: () => MemberRoute
          })
const MemberCertificationsRoute = MemberCertificationsRouteImport.update({
            id: '/certifications',path: '/certifications',getParentRoute: () => MemberRoute
          })
const MemberCommunityPostsRoute = MemberCommunityPostsRouteImport.update({
            id: '/community-posts',path: '/community-posts',getParentRoute: () => MemberRoute
          })
const MemberContributeRoute = MemberContributeRouteImport.update({
            id: '/contribute',path: '/contribute',getParentRoute: () => MemberRoute
          })
const MemberDashboardRoute = MemberDashboardRouteImport.update({
            id: '/dashboard',path: '/dashboard',getParentRoute: () => MemberRoute
          })
const MemberDirectoryRoute = MemberDirectoryRouteImport.update({
            id: '/directory',path: '/directory',getParentRoute: () => MemberRoute
          })
const MemberEndorsementsRoute = MemberEndorsementsRouteImport.update({
            id: '/endorsements',path: '/endorsements',getParentRoute: () => MemberRoute
          })
const MemberEventsRoute = MemberEventsRouteImport.update({
            id: '/events',path: '/events',getParentRoute: () => MemberRoute
          })
const MemberLeaderboardRoute = MemberLeaderboardRouteImport.update({
            id: '/leaderboard',path: '/leaderboard',getParentRoute: () => MemberRoute
          })
const MemberLoginRoute = MemberLoginRouteImport.update({
            id: '/login',path: '/login',getParentRoute: () => MemberRoute
          })
const MemberMessagesRoute = MemberMessagesRouteImport.update({
            id: '/messages',path: '/messages',getParentRoute: () => MemberRoute
          })
const MemberOfficeHoursRoute = MemberOfficeHoursRouteImport.update({
            id: '/office-hours',path: '/office-hours',getParentRoute: () => MemberRoute
          })
const MemberOpportunitiesRoute = MemberOpportunitiesRouteImport.update({
            id: '/opportunities',path: '/opportunities',getParentRoute: () => MemberRoute
          })
const MemberProfileRoute = MemberProfileRouteImport.update({
            id: '/profile',path: '/profile',getParentRoute: () => MemberRoute
          })
const MemberPublicationsRoute = MemberPublicationsRouteImport.update({
            id: '/publications',path: '/publications',getParentRoute: () => MemberRoute
          })
const MemberResourcesRoute = MemberResourcesRouteImport.update({
            id: '/resources',path: '/resources',getParentRoute: () => MemberRoute
          })
const MemberSettingsRoute = MemberSettingsRouteImport.update({
            id: '/settings',path: '/settings',getParentRoute: () => MemberRoute
          })
const MemberSetupRoute = MemberSetupRouteImport.update({
            id: '/setup',path: '/setup',getParentRoute: () => MemberRoute
          })
const MemberResetPasswordRoute = MemberResetPasswordRouteImport.update({
            id: '/member_/reset-password',path: '/member/reset-password',getParentRoute: () => rootRouteImport
          })
const NewsletterSplatRoute = NewsletterSplatRouteImport.update({
            id: '/newsletter/$',path: '/newsletter/$',getParentRoute: () => rootRouteImport
          })
const PartnerIndexRoute = PartnerIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => PartnerRoute
          })
const PartnerSplatRoute = PartnerSplatRouteImport.update({
            id: '/$',path: '/$',getParentRoute: () => PartnerRoute
          })
const PartnerCompanyRoute = PartnerCompanyRouteImport.update({
            id: '/company',path: '/company',getParentRoute: () => PartnerRoute
          })
const PartnerDashboardRoute = PartnerDashboardRouteImport.update({
            id: '/dashboard',path: '/dashboard',getParentRoute: () => PartnerRoute
          })
const PartnerDocumentsRoute = PartnerDocumentsRouteImport.update({
            id: '/documents',path: '/documents',getParentRoute: () => PartnerRoute
          })
const PartnerPerformanceRoute = PartnerPerformanceRouteImport.update({
            id: '/performance',path: '/performance',getParentRoute: () => PartnerRoute
          })
const PartnerProfileRoute = PartnerProfileRouteImport.update({
            id: '/profile',path: '/profile',getParentRoute: () => PartnerRoute
          })
const PartnerSettingsRoute = PartnerSettingsRouteImport.update({
            id: '/settings',path: '/settings',getParentRoute: () => PartnerRoute
          })
const PartnerSubmissionsRoute = PartnerSubmissionsRouteImport.update({
            id: '/submissions',path: '/submissions',getParentRoute: () => PartnerRoute
          })
const PartnerWorkRoute = PartnerWorkRouteImport.update({
            id: '/work',path: '/work',getParentRoute: () => PartnerRoute
          })
const PartnerActivateRoute = PartnerActivateRouteImport.update({
            id: '/partner_/activate',path: '/partner/activate',getParentRoute: () => rootRouteImport
          })
const PartnerResetPasswordRoute = PartnerResetPasswordRouteImport.update({
            id: '/partner_/reset-password',path: '/partner/reset-password',getParentRoute: () => rootRouteImport
          })
const PartnerSetupRoute = PartnerSetupRouteImport.update({
            id: '/partner_/setup',path: '/partner/setup',getParentRoute: () => rootRouteImport
          })
const ProductsIndexRoute = ProductsIndexRouteImport.update({
            id: '/products/',path: '/products/',getParentRoute: () => rootRouteImport
          })
const ProductsAgenticEnterprisePlatformRoute = ProductsAgenticEnterprisePlatformRouteImport.update({
            id: '/products/agentic-enterprise-platform',path: '/products/agentic-enterprise-platform',getParentRoute: () => rootRouteImport
          })
const ProductsAkivaInceptionRoute = ProductsAkivaInceptionRouteImport.update({
            id: '/products/akiva-inception',path: '/products/akiva-inception',getParentRoute: () => rootRouteImport
          })
const ProductsBiosRoute = ProductsBiosRouteImport.update({
            id: '/products/bios',path: '/products/bios',getParentRoute: () => rootRouteImport
          })
const ProductsComputeRoute = ProductsComputeRouteImport.update({
            id: '/products/compute',path: '/products/compute',getParentRoute: () => rootRouteImport
          })
const ProductsDatasyncEnterpriseRoute = ProductsDatasyncEnterpriseRouteImport.update({
            id: '/products/datasync-enterprise',path: '/products/datasync-enterprise',getParentRoute: () => rootRouteImport
          })
const ProductsDecisionSupportRoute = ProductsDecisionSupportRouteImport.update({
            id: '/products/decision-support',path: '/products/decision-support',getParentRoute: () => rootRouteImport
          })
const ProductsHardwareRoute = ProductsHardwareRouteImport.update({
            id: '/products/hardware',path: '/products/hardware',getParentRoute: () => rootRouteImport
          })
const ProductsInceptionRoute = ProductsInceptionRouteImport.update({
            id: '/products/inception',path: '/products/inception',getParentRoute: () => rootRouteImport
          })
const ProductsMarketinsightProRoute = ProductsMarketinsightProRouteImport.update({
            id: '/products/marketinsight-pro',path: '/products/marketinsight-pro',getParentRoute: () => rootRouteImport
          })
const ProductsModelopsProRoute = ProductsModelopsProRouteImport.update({
            id: '/products/modelops-pro',path: '/products/modelops-pro',getParentRoute: () => rootRouteImport
          })
const ProductsNovaEnterpriseRoute = ProductsNovaEnterpriseRouteImport.update({
            id: '/products/nova-enterprise',path: '/products/nova-enterprise',getParentRoute: () => rootRouteImport
          })
const ProductsNovaHealthcareRoute = ProductsNovaHealthcareRouteImport.update({
            id: '/products/nova-healthcare',path: '/products/nova-healthcare',getParentRoute: () => rootRouteImport
          })
const ProductsNovaWorkspaceRoute = ProductsNovaWorkspaceRouteImport.update({
            id: '/products/nova-workspace',path: '/products/nova-workspace',getParentRoute: () => rootRouteImport
          })
const ProductsPerformancevisionProRoute = ProductsPerformancevisionProRouteImport.update({
            id: '/products/performancevision-pro',path: '/products/performancevision-pro',getParentRoute: () => rootRouteImport
          })
const ProductsSmartsourceProRoute = ProductsSmartsourceProRouteImport.update({
            id: '/products/smartsource-pro',path: '/products/smartsource-pro',getParentRoute: () => rootRouteImport
          })
const ProductsSoftwareRoute = ProductsSoftwareRouteImport.update({
            id: '/products/software',path: '/products/software',getParentRoute: () => rootRouteImport
          })
const ServiceAiEngineeringRoute = ServiceAiEngineeringRouteImport.update({
            id: '/service/ai-engineering',path: '/service/ai-engineering',getParentRoute: () => rootRouteImport
          })
const ServiceAiIntegrationRoute = ServiceAiIntegrationRouteImport.update({
            id: '/service/ai-integration',path: '/service/ai-integration',getParentRoute: () => rootRouteImport
          })
const ServiceAiSecurityRoute = ServiceAiSecurityRouteImport.update({
            id: '/service/ai-security',path: '/service/ai-security',getParentRoute: () => rootRouteImport
          })
const ServiceAiStrategyRoute = ServiceAiStrategyRouteImport.update({
            id: '/service/ai-strategy',path: '/service/ai-strategy',getParentRoute: () => rootRouteImport
          })
const ServiceComputerVisionRoute = ServiceComputerVisionRouteImport.update({
            id: '/service/computer-vision',path: '/service/computer-vision',getParentRoute: () => rootRouteImport
          })
const ServiceCybersecurityRoute = ServiceCybersecurityRouteImport.update({
            id: '/service/cybersecurity',path: '/service/cybersecurity',getParentRoute: () => rootRouteImport
          })
const ServiceDataEngineeringRoute = ServiceDataEngineeringRouteImport.update({
            id: '/service/data-engineering',path: '/service/data-engineering',getParentRoute: () => rootRouteImport
          })
const ServiceDigitalTransformationRoute = ServiceDigitalTransformationRouteImport.update({
            id: '/service/digital-transformation',path: '/service/digital-transformation',getParentRoute: () => rootRouteImport
          })
const ServiceEnterpriseItRoute = ServiceEnterpriseItRouteImport.update({
            id: '/service/enterprise-it',path: '/service/enterprise-it',getParentRoute: () => rootRouteImport
          })
const ServiceMlopsRoute = ServiceMlopsRouteImport.update({
            id: '/service/mlops',path: '/service/mlops',getParentRoute: () => rootRouteImport
          })
const ServiceMultiAgentSystemsRoute = ServiceMultiAgentSystemsRouteImport.update({
            id: '/service/multi-agent-systems',path: '/service/multi-agent-systems',getParentRoute: () => rootRouteImport
          })
const ServiceProgramManagementRoute = ServiceProgramManagementRouteImport.update({
            id: '/service/program-management',path: '/service/program-management',getParentRoute: () => rootRouteImport
          })
const ServiceStrategyConsultingRoute = ServiceStrategyConsultingRouteImport.update({
            id: '/service/strategy-consulting',path: '/service/strategy-consulting',getParentRoute: () => rootRouteImport
          })
const ServiceSupplyChainRoute = ServiceSupplyChainRouteImport.update({
            id: '/service/supply-chain',path: '/service/supply-chain',getParentRoute: () => rootRouteImport
          })
const SurveyTokenRoute = SurveyTokenRouteImport.update({
            id: '/survey/$token',path: '/survey/$token',getParentRoute: () => rootRouteImport
          })
const WpAdminSplatRoute = WpAdminSplatRouteImport.update({
            id: '/wp-admin/$',path: '/wp-admin/$',getParentRoute: () => rootRouteImport
          })
const WpContentSplatRoute = WpContentSplatRouteImport.update({
            id: '/wp-content/$',path: '/wp-content/$',getParentRoute: () => rootRouteImport
          })
const AdminAdminIndexRoute = AdminAdminIndexRouteImport.update({
            id: '/admin/',path: '/admin/',getParentRoute: () => AdminRoute
          })
const AdminAdminAccountsRoute = AdminAdminAccountsRouteImport.update({
            id: '/admin/accounts',path: '/admin/accounts',getParentRoute: () => AdminRoute
          })
const AdminAdminAchievementsRoute = AdminAdminAchievementsRouteImport.update({
            id: '/admin/achievements',path: '/admin/achievements',getParentRoute: () => AdminRoute
          })
const AdminAdminAiToolSuggestionsRoute = AdminAdminAiToolSuggestionsRouteImport.update({
            id: '/admin/ai-tool-suggestions',path: '/admin/ai-tool-suggestions',getParentRoute: () => AdminRoute
          })
const AdminAdminAnnouncementsRoute = AdminAdminAnnouncementsRouteImport.update({
            id: '/admin/announcements',path: '/admin/announcements',getParentRoute: () => AdminRoute
          })
const AdminAdminApiDocsRoute = AdminAdminApiDocsRouteImport.update({
            id: '/admin/api-docs',path: '/admin/api-docs',getParentRoute: () => AdminRoute
          })
const AdminAdminAuditLogsRoute = AdminAdminAuditLogsRouteImport.update({
            id: '/admin/audit-logs',path: '/admin/audit-logs',getParentRoute: () => AdminRoute
          })
const AdminAdminCandidatePipelineRoute = AdminAdminCandidatePipelineRouteImport.update({
            id: '/admin/candidate-pipeline',path: '/admin/candidate-pipeline',getParentRoute: () => AdminRoute
          })
const AdminAdminCareersRoute = AdminAdminCareersRouteImport.update({
            id: '/admin/careers',path: '/admin/careers',getParentRoute: () => AdminRoute
          })
const AdminAdminCareersProfileRoute = AdminAdminCareersProfileRouteImport.update({
            id: '/admin/careers-profile',path: '/admin/careers-profile',getParentRoute: () => AdminRoute
          })
const AdminAdminClientAccountsRoute = AdminAdminClientAccountsRouteImport.update({
            id: '/admin/client-accounts',path: '/admin/client-accounts',getParentRoute: () => AdminRoute
          })
const AdminAdminClientContactsRoute = AdminAdminClientContactsRouteImport.update({
            id: '/admin/client-contacts',path: '/admin/client-contacts',getParentRoute: () => AdminRoute
          })
const AdminAdminClientFeedbackRoute = AdminAdminClientFeedbackRouteImport.update({
            id: '/admin/client-feedback',path: '/admin/client-feedback',getParentRoute: () => AdminRoute
          })
const AdminAdminCommunityProgramsRoute = AdminAdminCommunityProgramsRouteImport.update({
            id: '/admin/community-programs',path: '/admin/community-programs',getParentRoute: () => AdminRoute
          })
const AdminAdminContactInquiriesRoute = AdminAdminContactInquiriesRouteImport.update({
            id: '/admin/contact-inquiries',path: '/admin/contact-inquiries',getParentRoute: () => AdminRoute
          })
const AdminAdminContentRoute = AdminAdminContentRouteImport.update({
            id: '/admin/content',path: '/admin/content',getParentRoute: () => AdminRoute
          })
const AdminAdminCrossModuleReportRoute = AdminAdminCrossModuleReportRouteImport.update({
            id: '/admin/cross-module-report',path: '/admin/cross-module-report',getParentRoute: () => AdminRoute
          })
const AdminAdminDigestPreviewRoute = AdminAdminDigestPreviewRouteImport.update({
            id: '/admin/digest-preview',path: '/admin/digest-preview',getParentRoute: () => AdminRoute
          })
const AdminAdminDocumentIntakeRoute = AdminAdminDocumentIntakeRouteImport.update({
            id: '/admin/document-intake',path: '/admin/document-intake',getParentRoute: () => AdminRoute
          })
const AdminAdminEmailGalleryRoute = AdminAdminEmailGalleryRouteImport.update({
            id: '/admin/email-gallery',path: '/admin/email-gallery',getParentRoute: () => AdminRoute
          })
const AdminAdminEmailSchedulerRoute = AdminAdminEmailSchedulerRouteImport.update({
            id: '/admin/email-scheduler',path: '/admin/email-scheduler',getParentRoute: () => AdminRoute
          })
const AdminAdminEmailTemplatesRoute = AdminAdminEmailTemplatesRouteImport.update({
            id: '/admin/email-templates',path: '/admin/email-templates',getParentRoute: () => AdminRoute
          })
const AdminAdminEmployeesRoute = AdminAdminEmployeesRouteImport.update({
            id: '/admin/employees',path: '/admin/employees',getParentRoute: () => AdminRoute
          })
const AdminAdminEventsRoute = AdminAdminEventsRouteImport.update({
            id: '/admin/events',path: '/admin/events',getParentRoute: () => AdminRoute
          })
const AdminAdminExecDashboardRoute = AdminAdminExecDashboardRouteImport.update({
            id: '/admin/exec-dashboard',path: '/admin/exec-dashboard',getParentRoute: () => AdminRoute
          })
const AdminAdminExternalToolsRoute = AdminAdminExternalToolsRouteImport.update({
            id: '/admin/external-tools',path: '/admin/external-tools',getParentRoute: () => AdminRoute
          })
const AdminAdminForumModerationRoute = AdminAdminForumModerationRouteImport.update({
            id: '/admin/forum-moderation',path: '/admin/forum-moderation',getParentRoute: () => AdminRoute
          })
const AdminAdminFundingTrackerRoute = AdminAdminFundingTrackerRouteImport.update({
            id: '/admin/funding-tracker',path: '/admin/funding-tracker',getParentRoute: () => AdminRoute
          })
const AdminAdminInboundEmailRoute = AdminAdminInboundEmailRouteImport.update({
            id: '/admin/inbound-email',path: '/admin/inbound-email',getParentRoute: () => AdminRoute
          })
const AdminAdminInterviewSlotsRoute = AdminAdminInterviewSlotsRouteImport.update({
            id: '/admin/interview-slots',path: '/admin/interview-slots',getParentRoute: () => AdminRoute
          })
const AdminAdminInvitationAnalyticsRoute = AdminAdminInvitationAnalyticsRouteImport.update({
            id: '/admin/invitation-analytics',path: '/admin/invitation-analytics',getParentRoute: () => AdminRoute
          })
const AdminAdminInvoicesRoute = AdminAdminInvoicesRouteImport.update({
            id: '/admin/invoices',path: '/admin/invoices',getParentRoute: () => AdminRoute
          })
const AdminAdminJobBoardsRoute = AdminAdminJobBoardsRouteImport.update({
            id: '/admin/job-boards',path: '/admin/job-boards',getParentRoute: () => AdminRoute
          })
const AdminAdminJobSyndicationRoute = AdminAdminJobSyndicationRouteImport.update({
            id: '/admin/job-syndication',path: '/admin/job-syndication',getParentRoute: () => AdminRoute
          })
const AdminAdminLaborCategoriesRoute = AdminAdminLaborCategoriesRouteImport.update({
            id: '/admin/labor-categories',path: '/admin/labor-categories',getParentRoute: () => AdminRoute
          })
const AdminAdminLoginRoute = AdminAdminLoginRouteImport.update({
            id: '/admin/login',path: '/admin/login',getParentRoute: () => AdminRoute
          })
const AdminAdminMemberInboxRoute = AdminAdminMemberInboxRouteImport.update({
            id: '/admin/member-inbox',path: '/admin/member-inbox',getParentRoute: () => AdminRoute
          })
const AdminAdminMfaResetRoute = AdminAdminMfaResetRouteImport.update({
            id: '/admin/mfa-reset',path: '/admin/mfa-reset',getParentRoute: () => AdminRoute
          })
const AdminAdminNetworkAnnouncementsRoute = AdminAdminNetworkAnnouncementsRouteImport.update({
            id: '/admin/network-announcements',path: '/admin/network-announcements',getParentRoute: () => AdminRoute
          })
const AdminAdminNewsletterRoute = AdminAdminNewsletterRouteImport.update({
            id: '/admin/newsletter',path: '/admin/newsletter',getParentRoute: () => AdminRoute
          })
const AdminAdminOperationsRoute = AdminAdminOperationsRouteImport.update({
            id: '/admin/operations',path: '/admin/operations',getParentRoute: () => AdminRoute
          })
const AdminAdminOptionCalendarRoute = AdminAdminOptionCalendarRouteImport.update({
            id: '/admin/option-calendar',path: '/admin/option-calendar',getParentRoute: () => AdminRoute
          })
const AdminAdminOrganizationsRoute = AdminAdminOrganizationsRouteImport.update({
            id: '/admin/organizations',path: '/admin/organizations',getParentRoute: () => AdminRoute
          })
const AdminAdminPartnerAccountsRoute = AdminAdminPartnerAccountsRouteImport.update({
            id: '/admin/partner-accounts',path: '/admin/partner-accounts',getParentRoute: () => AdminRoute
          })
const AdminAdminPartnersRoute = AdminAdminPartnersRouteImport.update({
            id: '/admin/partners',path: '/admin/partners',getParentRoute: () => AdminRoute
          })
const AdminAdminPerformanceKpiRoute = AdminAdminPerformanceKpiRouteImport.update({
            id: '/admin/performance-kpi',path: '/admin/performance-kpi',getParentRoute: () => AdminRoute
          })
const AdminAdminPlatformEventsRoute = AdminAdminPlatformEventsRouteImport.update({
            id: '/admin/platform-events',path: '/admin/platform-events',getParentRoute: () => AdminRoute
          })
const AdminAdminProjectEvmRoute = AdminAdminProjectEvmRouteImport.update({
            id: '/admin/project-evm',path: '/admin/project-evm',getParentRoute: () => AdminRoute
          })
const AdminAdminProjectInterestsRoute = AdminAdminProjectInterestsRouteImport.update({
            id: '/admin/project-interests',path: '/admin/project-interests',getParentRoute: () => AdminRoute
          })
const AdminAdminProjectReportingRoute = AdminAdminProjectReportingRouteImport.update({
            id: '/admin/project-reporting',path: '/admin/project-reporting',getParentRoute: () => AdminRoute
          })
const AdminAdminProjectsRoute = AdminAdminProjectsRouteImport.update({
            id: '/admin/projects',path: '/admin/projects',getParentRoute: () => AdminRoute
          })
const AdminAdminQualityDeliverablesRoute = AdminAdminQualityDeliverablesRouteImport.update({
            id: '/admin/quality-deliverables',path: '/admin/quality-deliverables',getParentRoute: () => AdminRoute
          })
const AdminAdminQualityMetricsRoute = AdminAdminQualityMetricsRouteImport.update({
            id: '/admin/quality-metrics',path: '/admin/quality-metrics',getParentRoute: () => AdminRoute
          })
const AdminAdminQuickLinksRoute = AdminAdminQuickLinksRouteImport.update({
            id: '/admin/quick-links',path: '/admin/quick-links',getParentRoute: () => AdminRoute
          })
const AdminAdminReferralsRoute = AdminAdminReferralsRouteImport.update({
            id: '/admin/referrals',path: '/admin/referrals',getParentRoute: () => AdminRoute
          })
const AdminAdminResetPasswordRoute = AdminAdminResetPasswordRouteImport.update({
            id: '/admin/reset-password',path: '/admin/reset-password',getParentRoute: () => AdminRoute
          })
const AdminAdminResourceSuggestionsRoute = AdminAdminResourceSuggestionsRouteImport.update({
            id: '/admin/resource-suggestions',path: '/admin/resource-suggestions',getParentRoute: () => AdminRoute
          })
const AdminAdminResourcesRoute = AdminAdminResourcesRouteImport.update({
            id: '/admin/resources',path: '/admin/resources',getParentRoute: () => AdminRoute
          })
const AdminAdminRiskComplianceRoute = AdminAdminRiskComplianceRouteImport.update({
            id: '/admin/risk-compliance',path: '/admin/risk-compliance',getParentRoute: () => AdminRoute
          })
const AdminAdminSecurityRoute = AdminAdminSecurityRouteImport.update({
            id: '/admin/security',path: '/admin/security',getParentRoute: () => AdminRoute
          })
const AdminAdminStaffingAssignmentsRoute = AdminAdminStaffingAssignmentsRouteImport.update({
            id: '/admin/staffing-assignments',path: '/admin/staffing-assignments',getParentRoute: () => AdminRoute
          })
const AdminAdminStaffingComplianceRoute = AdminAdminStaffingComplianceRouteImport.update({
            id: '/admin/staffing-compliance',path: '/admin/staffing-compliance',getParentRoute: () => AdminRoute
          })
const AdminAdminTalentRoute = AdminAdminTalentRouteImport.update({
            id: '/admin/talent',path: '/admin/talent',getParentRoute: () => AdminRoute
          })
const AdminAdminTalentDirectoryRoute = AdminAdminTalentDirectoryRouteImport.update({
            id: '/admin/talent-directory',path: '/admin/talent-directory',getParentRoute: () => AdminRoute
          })
const AdminAdminTalentRequestsRoute = AdminAdminTalentRequestsRouteImport.update({
            id: '/admin/talent-requests',path: '/admin/talent-requests',getParentRoute: () => AdminRoute
          })
const AdminAdminTalentSearchRoute = AdminAdminTalentSearchRouteImport.update({
            id: '/admin/talent-search',path: '/admin/talent-search',getParentRoute: () => AdminRoute
          })
const AdminAdminTaskOrdersRoute = AdminAdminTaskOrdersRouteImport.update({
            id: '/admin/task-orders',path: '/admin/task-orders',getParentRoute: () => AdminRoute
          })
const AdminAdminTimesheetsRoute = AdminAdminTimesheetsRouteImport.update({
            id: '/admin/timesheets',path: '/admin/timesheets',getParentRoute: () => AdminRoute
          })
const AdminAdminUserManagementRoute = AdminAdminUserManagementRouteImport.update({
            id: '/admin/user-management',path: '/admin/user-management',getParentRoute: () => AdminRoute
          })
const AdminAdminVacancyForecastRoute = AdminAdminVacancyForecastRouteImport.update({
            id: '/admin/vacancy-forecast',path: '/admin/vacancy-forecast',getParentRoute: () => AdminRoute
          })
const AdminAdminVisitorAnalyticsRoute = AdminAdminVisitorAnalyticsRouteImport.update({
            id: '/admin/visitor-analytics',path: '/admin/visitor-analytics',getParentRoute: () => AdminRoute
          })
const CareersJobsIndexRoute = CareersJobsIndexRouteImport.update({
            id: '/careers/jobs/',path: '/careers/jobs/',getParentRoute: () => rootRouteImport
          })
const CareersResumeReuploadTokenRoute = CareersResumeReuploadTokenRouteImport.update({
            id: '/careers/resume-reupload/$token',path: '/careers/resume-reupload/$token',getParentRoute: () => rootRouteImport
          })
const ClientInviteActivateRoute = ClientInviteActivateRouteImport.update({
            id: '/client_/invite/activate',path: '/client/invite/activate',getParentRoute: () => rootRouteImport
          })
const CompanyPressIndexRoute = CompanyPressIndexRouteImport.update({
            id: '/company/press/',path: '/company/press/',getParentRoute: () => rootRouteImport
          })
const CompanyPressSplatRoute = CompanyPressSplatRouteImport.update({
            id: '/company/press/$',path: '/company/press/$',getParentRoute: () => rootRouteImport
          })
const MemberAuthCallbackRoute = MemberAuthCallbackRouteImport.update({
            id: '/auth/callback',path: '/auth/callback',getParentRoute: () => MemberRoute
          })
const MemberForumsIndexRoute = MemberForumsIndexRouteImport.update({
            id: '/forums/',path: '/forums/',getParentRoute: () => MemberRoute
          })
const MemberForumsNewRoute = MemberForumsNewRouteImport.update({
            id: '/forums/new',path: '/forums/new',getParentRoute: () => MemberRoute
          })
const MemberMentorshipIndexRoute = MemberMentorshipIndexRouteImport.update({
            id: '/mentorship/',path: '/mentorship/',getParentRoute: () => MemberRoute
          })
const MemberMentorshipDashboardRoute = MemberMentorshipDashboardRouteImport.update({
            id: '/mentorship/dashboard',path: '/mentorship/dashboard',getParentRoute: () => MemberRoute
          })
const MemberProjectsIndexRoute = MemberProjectsIndexRouteImport.update({
            id: '/projects/',path: '/projects/',getParentRoute: () => MemberRoute
          })
const MemberProjectsIdRoute = MemberProjectsIdRouteImport.update({
            id: '/projects/$id',path: '/projects/$id',getParentRoute: () => MemberRoute
          })
const MemberInviteActivateRoute = MemberInviteActivateRouteImport.update({
            id: '/member_/invite/activate',path: '/member/invite/activate',getParentRoute: () => rootRouteImport
          })
const ProductsChatspaceSplatRoute = ProductsChatspaceSplatRouteImport.update({
            id: '/products/chatspace/$',path: '/products/chatspace/$',getParentRoute: () => rootRouteImport
          })
const ProductsMindcruiserSplatRoute = ProductsMindcruiserSplatRouteImport.update({
            id: '/products/mindcruiser/$',path: '/products/mindcruiser/$',getParentRoute: () => rootRouteImport
          })
const ProductsWebboardSplatRoute = ProductsWebboardSplatRouteImport.update({
            id: '/products/webboard/$',path: '/products/webboard/$',getParentRoute: () => rootRouteImport
          })
const AdminAdminClientsIndexRoute = AdminAdminClientsIndexRouteImport.update({
            id: '/admin/clients/',path: '/admin/clients/',getParentRoute: () => AdminRoute
          })
const AdminAdminClientsIdRoute = AdminAdminClientsIdRouteImport.update({
            id: '/admin/clients/$id',path: '/admin/clients/$id',getParentRoute: () => AdminRoute
          })
const AdminAdminContractsIndexRoute = AdminAdminContractsIndexRouteImport.update({
            id: '/admin/contracts/',path: '/admin/contracts/',getParentRoute: () => AdminRoute
          })
const AdminAdminContractsIdRoute = AdminAdminContractsIdRouteImport.update({
            id: '/admin/contracts/$id',path: '/admin/contracts/$id',getParentRoute: () => AdminRoute
          })
const AdminAdminPerformanceActionsRoute = AdminAdminPerformanceActionsRouteImport.update({
            id: '/admin/performance/actions',path: '/admin/performance/actions',getParentRoute: () => AdminRoute
          })
const AdminAdminPerformanceAiSuggestionsRoute = AdminAdminPerformanceAiSuggestionsRouteImport.update({
            id: '/admin/performance/ai-suggestions',path: '/admin/performance/ai-suggestions',getParentRoute: () => AdminRoute
          })
const AdminAdminPerformanceGoalProposalsRoute = AdminAdminPerformanceGoalProposalsRouteImport.update({
            id: '/admin/performance/goal-proposals',path: '/admin/performance/goal-proposals',getParentRoute: () => AdminRoute
          })
const AdminAdminPerformanceResourcesRoute = AdminAdminPerformanceResourcesRouteImport.update({
            id: '/admin/performance/resources',path: '/admin/performance/resources',getParentRoute: () => AdminRoute
          })
const AdminAdminPerformanceTeamPulseRoute = AdminAdminPerformanceTeamPulseRouteImport.update({
            id: '/admin/performance/team-pulse',path: '/admin/performance/team-pulse',getParentRoute: () => AdminRoute
          })
const AdminAdminPerformanceTriageRoute = AdminAdminPerformanceTriageRouteImport.update({
            id: '/admin/performance/triage',path: '/admin/performance/triage',getParentRoute: () => AdminRoute
          })
const AdminAdminRequisitionsIndexRoute = AdminAdminRequisitionsIndexRouteImport.update({
            id: '/admin/requisitions/',path: '/admin/requisitions/',getParentRoute: () => AdminRoute
          })
const AdminAdminRequisitionsIdRoute = AdminAdminRequisitionsIdRouteImport.update({
            id: '/admin/requisitions/$id',path: '/admin/requisitions/$id',getParentRoute: () => AdminRoute
          })
const AdminAdminSubcontractorsIndexRoute = AdminAdminSubcontractorsIndexRouteImport.update({
            id: '/admin/subcontractors/',path: '/admin/subcontractors/',getParentRoute: () => AdminRoute
          })
const AdminAdminSubcontractorsIdRoute = AdminAdminSubcontractorsIdRouteImport.update({
            id: '/admin/subcontractors/$id',path: '/admin/subcontractors/$id',getParentRoute: () => AdminRoute
          })
const CareersJobsSlugIndexRoute = CareersJobsSlugIndexRouteImport.update({
            id: '/careers/jobs/$slug/',path: '/careers/jobs/$slug/',getParentRoute: () => rootRouteImport
          })
const CareersJobsSlugApplyRoute = CareersJobsSlugApplyRouteImport.update({
            id: '/careers/jobs/$slug/apply',path: '/careers/jobs/$slug/apply',getParentRoute: () => rootRouteImport
          })
const ClientContractsContractIdIndexRoute = ClientContractsContractIdIndexRouteImport.update({
            id: '/contracts/$contractId/',path: '/contracts/$contractId/',getParentRoute: () => ClientRoute
          })
const ClientContractsContractIdInvoicesRoute = ClientContractsContractIdInvoicesRouteImport.update({
            id: '/contracts/$contractId/invoices',path: '/contracts/$contractId/invoices',getParentRoute: () => ClientRoute
          })
const ClientContractsContractIdKpisRoute = ClientContractsContractIdKpisRouteImport.update({
            id: '/contracts/$contractId/kpis',path: '/contracts/$contractId/kpis',getParentRoute: () => ClientRoute
          })
const ClientContractsContractIdQaspRoute = ClientContractsContractIdQaspRouteImport.update({
            id: '/contracts/$contractId/qasp',path: '/contracts/$contractId/qasp',getParentRoute: () => ClientRoute
          })
const ClientContractsContractIdReportsRoute = ClientContractsContractIdReportsRouteImport.update({
            id: '/contracts/$contractId/reports',path: '/contracts/$contractId/reports',getParentRoute: () => ClientRoute
          })
const ClientContractsContractIdRequestsRoute = ClientContractsContractIdRequestsRouteImport.update({
            id: '/contracts/$contractId/requests',path: '/contracts/$contractId/requests',getParentRoute: () => ClientRoute
          })
const ClientContractsContractIdRisksRoute = ClientContractsContractIdRisksRouteImport.update({
            id: '/contracts/$contractId/risks',path: '/contracts/$contractId/risks',getParentRoute: () => ClientRoute
          })
const ClientContractsContractIdStaffingRoute = ClientContractsContractIdStaffingRouteImport.update({
            id: '/contracts/$contractId/staffing',path: '/contracts/$contractId/staffing',getParentRoute: () => ClientRoute
          })
const ClientContractsContractIdTimesheetsRoute = ClientContractsContractIdTimesheetsRouteImport.update({
            id: '/contracts/$contractId/timesheets',path: '/contracts/$contractId/timesheets',getParentRoute: () => ClientRoute
          })
const ClientContractsContractIdVacanciesRoute = ClientContractsContractIdVacanciesRouteImport.update({
            id: '/contracts/$contractId/vacancies',path: '/contracts/$contractId/vacancies',getParentRoute: () => ClientRoute
          })
const MemberForumsThreadThreadIdRoute = MemberForumsThreadThreadIdRouteImport.update({
            id: '/forums/thread/$threadId',path: '/forums/thread/$threadId',getParentRoute: () => MemberRoute
          })
const AdminAdminPerformanceCyclesIndexRoute = AdminAdminPerformanceCyclesIndexRouteImport.update({
            id: '/admin/performance/cycles/',path: '/admin/performance/cycles/',getParentRoute: () => AdminRoute
          })
const AdminAdminPerformanceCyclesIdRoute = AdminAdminPerformanceCyclesIdRouteImport.update({
            id: '/admin/performance/cycles/$id',path: '/admin/performance/cycles/$id',getParentRoute: () => AdminRoute
          })
const AdminAdminPerformanceEmployeesIndexRoute = AdminAdminPerformanceEmployeesIndexRouteImport.update({
            id: '/admin/performance/employees/',path: '/admin/performance/employees/',getParentRoute: () => AdminRoute
          })
const AdminAdminPerformanceEmployeesIdRoute = AdminAdminPerformanceEmployeesIdRouteImport.update({
            id: '/admin/performance/employees/$id',path: '/admin/performance/employees/$id',getParentRoute: () => AdminRoute
          })
const AdminAdminPerformancePipIndexRoute = AdminAdminPerformancePipIndexRouteImport.update({
            id: '/admin/performance/pip/',path: '/admin/performance/pip/',getParentRoute: () => AdminRoute
          })
const AdminAdminPerformancePipPipIdRoute = AdminAdminPerformancePipPipIdRouteImport.update({
            id: '/admin/performance/pip/$pipId',path: '/admin/performance/pip/$pipId',getParentRoute: () => AdminRoute
          })
const AdminAdminPerformancePipNewRoute = AdminAdminPerformancePipNewRouteImport.update({
            id: '/admin/performance/pip/new',path: '/admin/performance/pip/new',getParentRoute: () => AdminRoute
          })
const ClientContractsContractIdDeliverablesIndexRoute = ClientContractsContractIdDeliverablesIndexRouteImport.update({
            id: '/contracts/$contractId/deliverables/',path: '/contracts/$contractId/deliverables/',getParentRoute: () => ClientRoute
          })
const ClientContractsContractIdDeliverablesDeliverableIdRoute = ClientContractsContractIdDeliverablesDeliverableIdRouteImport.update({
            id: '/contracts/$contractId/deliverables/$deliverableId',path: '/contracts/$contractId/deliverables/$deliverableId',getParentRoute: () => ClientRoute
          })





const AdminRouteChildren = {
  AdminAdminAccountsRoute: AdminAdminAccountsRoute,AdminAdminAchievementsRoute: AdminAdminAchievementsRoute,AdminAdminAiToolSuggestionsRoute: AdminAdminAiToolSuggestionsRoute,AdminAdminAnnouncementsRoute: AdminAdminAnnouncementsRoute,AdminAdminApiDocsRoute: AdminAdminApiDocsRoute,AdminAdminAuditLogsRoute: AdminAdminAuditLogsRoute,AdminAdminCandidatePipelineRoute: AdminAdminCandidatePipelineRoute,AdminAdminCareersRoute: AdminAdminCareersRoute,AdminAdminCareersProfileRoute: AdminAdminCareersProfileRoute,AdminAdminClientAccountsRoute: AdminAdminClientAccountsRoute,AdminAdminClientContactsRoute: AdminAdminClientContactsRoute,AdminAdminClientFeedbackRoute: AdminAdminClientFeedbackRoute,AdminAdminCommunityProgramsRoute: AdminAdminCommunityProgramsRoute,AdminAdminContactInquiriesRoute: AdminAdminContactInquiriesRoute,AdminAdminContentRoute: AdminAdminContentRoute,AdminAdminCrossModuleReportRoute: AdminAdminCrossModuleReportRoute,AdminAdminDigestPreviewRoute: AdminAdminDigestPreviewRoute,AdminAdminDocumentIntakeRoute: AdminAdminDocumentIntakeRoute,AdminAdminEmailGalleryRoute: AdminAdminEmailGalleryRoute,AdminAdminEmailSchedulerRoute: AdminAdminEmailSchedulerRoute,AdminAdminEmailTemplatesRoute: AdminAdminEmailTemplatesRoute,AdminAdminEmployeesRoute: AdminAdminEmployeesRoute,AdminAdminEventsRoute: AdminAdminEventsRoute,AdminAdminExecDashboardRoute: AdminAdminExecDashboardRoute,AdminAdminExternalToolsRoute: AdminAdminExternalToolsRoute,AdminAdminForumModerationRoute: AdminAdminForumModerationRoute,AdminAdminFundingTrackerRoute: AdminAdminFundingTrackerRoute,AdminAdminInboundEmailRoute: AdminAdminInboundEmailRoute,AdminAdminInterviewSlotsRoute: AdminAdminInterviewSlotsRoute,AdminAdminInvitationAnalyticsRoute: AdminAdminInvitationAnalyticsRoute,AdminAdminInvoicesRoute: AdminAdminInvoicesRoute,AdminAdminJobBoardsRoute: AdminAdminJobBoardsRoute,AdminAdminJobSyndicationRoute: AdminAdminJobSyndicationRoute,AdminAdminLaborCategoriesRoute: AdminAdminLaborCategoriesRoute,AdminAdminLoginRoute: AdminAdminLoginRoute,AdminAdminMemberInboxRoute: AdminAdminMemberInboxRoute,AdminAdminMfaResetRoute: AdminAdminMfaResetRoute,AdminAdminNetworkAnnouncementsRoute: AdminAdminNetworkAnnouncementsRoute,AdminAdminNewsletterRoute: AdminAdminNewsletterRoute,AdminAdminOperationsRoute: AdminAdminOperationsRoute,AdminAdminOptionCalendarRoute: AdminAdminOptionCalendarRoute,AdminAdminOrganizationsRoute: AdminAdminOrganizationsRoute,AdminAdminPartnerAccountsRoute: AdminAdminPartnerAccountsRoute,AdminAdminPartnersRoute: AdminAdminPartnersRoute,AdminAdminPerformanceKpiRoute: AdminAdminPerformanceKpiRoute,AdminAdminPlatformEventsRoute: AdminAdminPlatformEventsRoute,AdminAdminProjectEvmRoute: AdminAdminProjectEvmRoute,AdminAdminProjectInterestsRoute: AdminAdminProjectInterestsRoute,AdminAdminProjectReportingRoute: AdminAdminProjectReportingRoute,AdminAdminProjectsRoute: AdminAdminProjectsRoute,AdminAdminQualityDeliverablesRoute: AdminAdminQualityDeliverablesRoute,AdminAdminQualityMetricsRoute: AdminAdminQualityMetricsRoute,AdminAdminQuickLinksRoute: AdminAdminQuickLinksRoute,AdminAdminReferralsRoute: AdminAdminReferralsRoute,AdminAdminResetPasswordRoute: AdminAdminResetPasswordRoute,AdminAdminResourceSuggestionsRoute: AdminAdminResourceSuggestionsRoute,AdminAdminResourcesRoute: AdminAdminResourcesRoute,AdminAdminRiskComplianceRoute: AdminAdminRiskComplianceRoute,AdminAdminSecurityRoute: AdminAdminSecurityRoute,AdminAdminStaffingAssignmentsRoute: AdminAdminStaffingAssignmentsRoute,AdminAdminStaffingComplianceRoute: AdminAdminStaffingComplianceRoute,AdminAdminTalentRoute: AdminAdminTalentRoute,AdminAdminTalentDirectoryRoute: AdminAdminTalentDirectoryRoute,AdminAdminTalentRequestsRoute: AdminAdminTalentRequestsRoute,AdminAdminTalentSearchRoute: AdminAdminTalentSearchRoute,AdminAdminTaskOrdersRoute: AdminAdminTaskOrdersRoute,AdminAdminTimesheetsRoute: AdminAdminTimesheetsRoute,AdminAdminUserManagementRoute: AdminAdminUserManagementRoute,AdminAdminVacancyForecastRoute: AdminAdminVacancyForecastRoute,AdminAdminVisitorAnalyticsRoute: AdminAdminVisitorAnalyticsRoute,AdminAdminIndexRoute: AdminAdminIndexRoute,AdminAdminClientsIdRoute: AdminAdminClientsIdRoute,AdminAdminContractsIdRoute: AdminAdminContractsIdRoute,AdminAdminPerformanceActionsRoute: AdminAdminPerformanceActionsRoute,AdminAdminPerformanceAiSuggestionsRoute: AdminAdminPerformanceAiSuggestionsRoute,AdminAdminPerformanceGoalProposalsRoute: AdminAdminPerformanceGoalProposalsRoute,AdminAdminPerformanceResourcesRoute: AdminAdminPerformanceResourcesRoute,AdminAdminPerformanceTeamPulseRoute: AdminAdminPerformanceTeamPulseRoute,AdminAdminPerformanceTriageRoute: AdminAdminPerformanceTriageRoute,AdminAdminRequisitionsIdRoute: AdminAdminRequisitionsIdRoute,AdminAdminSubcontractorsIdRoute: AdminAdminSubcontractorsIdRoute,AdminAdminClientsIndexRoute: AdminAdminClientsIndexRoute,AdminAdminContractsIndexRoute: AdminAdminContractsIndexRoute,AdminAdminRequisitionsIndexRoute: AdminAdminRequisitionsIndexRoute,AdminAdminSubcontractorsIndexRoute: AdminAdminSubcontractorsIndexRoute,AdminAdminPerformanceCyclesIdRoute: AdminAdminPerformanceCyclesIdRoute,AdminAdminPerformanceEmployeesIdRoute: AdminAdminPerformanceEmployeesIdRoute,AdminAdminPerformancePipPipIdRoute: AdminAdminPerformancePipPipIdRoute,AdminAdminPerformancePipNewRoute: AdminAdminPerformancePipNewRoute,AdminAdminPerformanceCyclesIndexRoute: AdminAdminPerformanceCyclesIndexRoute,AdminAdminPerformanceEmployeesIndexRoute: AdminAdminPerformanceEmployeesIndexRoute,AdminAdminPerformancePipIndexRoute: AdminAdminPerformancePipIndexRoute
}

const AdminRouteWithChildren = AdminRoute._addFileChildren(AdminRouteChildren)




const ClientRouteChildren = {
  ClientSplatRoute: ClientSplatRoute,ClientContractRoute: ClientContractRoute,ClientDashboardRoute: ClientDashboardRoute,ClientDeliverablesRoute: ClientDeliverablesRoute,ClientFeedbackRoute: ClientFeedbackRoute,ClientInvoicesRoute: ClientInvoicesRoute,ClientKpisRoute: ClientKpisRoute,ClientLoginRoute: ClientLoginRoute,ClientQaspRoute: ClientQaspRoute,ClientReportsRoute: ClientReportsRoute,ClientRequestsRoute: ClientRequestsRoute,ClientRisksRoute: ClientRisksRoute,ClientSettingsRoute: ClientSettingsRoute,ClientSetupRoute: ClientSetupRoute,ClientStaffingRoute: ClientStaffingRoute,ClientTimesheetsRoute: ClientTimesheetsRoute,ClientUpdatesRoute: ClientUpdatesRoute,ClientVacanciesRoute: ClientVacanciesRoute,ClientContractsContractIdInvoicesRoute: ClientContractsContractIdInvoicesRoute,ClientContractsContractIdKpisRoute: ClientContractsContractIdKpisRoute,ClientContractsContractIdQaspRoute: ClientContractsContractIdQaspRoute,ClientContractsContractIdReportsRoute: ClientContractsContractIdReportsRoute,ClientContractsContractIdRequestsRoute: ClientContractsContractIdRequestsRoute,ClientContractsContractIdRisksRoute: ClientContractsContractIdRisksRoute,ClientContractsContractIdStaffingRoute: ClientContractsContractIdStaffingRoute,ClientContractsContractIdTimesheetsRoute: ClientContractsContractIdTimesheetsRoute,ClientContractsContractIdVacanciesRoute: ClientContractsContractIdVacanciesRoute,ClientContractsContractIdIndexRoute: ClientContractsContractIdIndexRoute,ClientContractsContractIdDeliverablesDeliverableIdRoute: ClientContractsContractIdDeliverablesDeliverableIdRoute,ClientContractsContractIdDeliverablesIndexRoute: ClientContractsContractIdDeliverablesIndexRoute
}

const ClientRouteWithChildren = ClientRoute._addFileChildren(ClientRouteChildren)




const EmployeeRouteChildren = {
  EmployeeSplatRoute: EmployeeSplatRoute,EmployeeDashboardRoute: EmployeeDashboardRoute,EmployeeDirectoryRoute: EmployeeDirectoryRoute,EmployeeLoginRoute: EmployeeLoginRoute,EmployeePerformanceRoute: EmployeePerformanceRoute,EmployeeProfileRoute: EmployeeProfileRoute,EmployeeReferralsRoute: EmployeeReferralsRoute,EmployeeResourcesRoute: EmployeeResourcesRoute,EmployeeSettingsRoute: EmployeeSettingsRoute,EmployeeTimesheetsRoute: EmployeeTimesheetsRoute
}

const EmployeeRouteWithChildren = EmployeeRoute._addFileChildren(EmployeeRouteChildren)




const MemberRouteChildren = {
  MemberSplatRoute: MemberSplatRoute,MemberAchievementsRoute: MemberAchievementsRoute,MemberAdminMessagesRoute: MemberAdminMessagesRoute,MemberAiToolsRoute: MemberAiToolsRoute,MemberAnnouncementsRoute: MemberAnnouncementsRoute,MemberCertificationsRoute: MemberCertificationsRoute,MemberCommunityPostsRoute: MemberCommunityPostsRoute,MemberContributeRoute: MemberContributeRoute,MemberDashboardRoute: MemberDashboardRoute,MemberDirectoryRoute: MemberDirectoryRoute,MemberEndorsementsRoute: MemberEndorsementsRoute,MemberEventsRoute: MemberEventsRoute,MemberLeaderboardRoute: MemberLeaderboardRoute,MemberLoginRoute: MemberLoginRoute,MemberMessagesRoute: MemberMessagesRoute,MemberOfficeHoursRoute: MemberOfficeHoursRoute,MemberOpportunitiesRoute: MemberOpportunitiesRoute,MemberProfileRoute: MemberProfileRoute,MemberPublicationsRoute: MemberPublicationsRoute,MemberResourcesRoute: MemberResourcesRoute,MemberSettingsRoute: MemberSettingsRoute,MemberSetupRoute: MemberSetupRoute,MemberAuthCallbackRoute: MemberAuthCallbackRoute,MemberForumsNewRoute: MemberForumsNewRoute,MemberMentorshipDashboardRoute: MemberMentorshipDashboardRoute,MemberProjectsIdRoute: MemberProjectsIdRoute,MemberForumsIndexRoute: MemberForumsIndexRoute,MemberMentorshipIndexRoute: MemberMentorshipIndexRoute,MemberProjectsIndexRoute: MemberProjectsIndexRoute,MemberForumsThreadThreadIdRoute: MemberForumsThreadThreadIdRoute
}

const MemberRouteWithChildren = MemberRoute._addFileChildren(MemberRouteChildren)




const PartnerRouteChildren = {
  PartnerSplatRoute: PartnerSplatRoute,PartnerCompanyRoute: PartnerCompanyRoute,PartnerDashboardRoute: PartnerDashboardRoute,PartnerDocumentsRoute: PartnerDocumentsRoute,PartnerPerformanceRoute: PartnerPerformanceRoute,PartnerProfileRoute: PartnerProfileRoute,PartnerSettingsRoute: PartnerSettingsRoute,PartnerSubmissionsRoute: PartnerSubmissionsRoute,PartnerWorkRoute: PartnerWorkRoute,PartnerIndexRoute: PartnerIndexRoute
}

const PartnerRouteWithChildren = PartnerRoute._addFileChildren(PartnerRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,AdminRoute: AdminRouteWithChildren,AboutRoute: AboutRoute,AiNetworkRoute: AiNetworkRoute,ApplyRoute: ApplyRoute,CertificationsRoute: CertificationsRoute,ClientRoute: ClientRouteWithChildren,CommercialRoute: CommercialRoute,ContactRoute: ContactRoute,ContractVehiclesRoute: ContractVehiclesRoute,ContributorsRoute: ContributorsRoute,EmailPreferencesRoute: EmailPreferencesRoute,EmployeeRoute: EmployeeRouteWithChildren,GovernmentRoute: GovernmentRoute,HomeRoute: HomeRoute,JobsRoute: JobsRoute,JobsDotxmlRoute: JobsDotxmlRoute,MemberRoute: MemberRouteWithChildren,NetworkInviteRoute: NetworkInviteRoute,NewsRoute: NewsRoute,PartnerRoute: PartnerRouteWithChildren,PartnerNetworkRoute: PartnerNetworkRoute,PartnershipRoute: PartnershipRoute,PrivacyRoute: PrivacyRoute,PrivacyPolicyRoute: PrivacyPolicyRoute,ResetPasswordRoute: ResetPasswordRoute,ServicesRoute: ServicesRoute,SignInRoute: SignInRoute,SitemapRoute: SitemapRoute,TalentNetworkRoute: TalentNetworkRoute,TalentRequestRoute: TalentRequestRoute,TermsOfServiceRoute: TermsOfServiceRoute,UnsubscribeRoute: UnsubscribeRoute,CareersCareersRoute: CareersCareersRoute,ClientResetPasswordRoute: ClientResetPasswordRoute,ContributorDashboardRoute: ContributorDashboardRoute,ContributorLoginRoute: ContributorLoginRoute,ContributorProfileRoute: ContributorProfileRoute,ContributorResetPasswordRoute: ContributorResetPasswordRoute,ContributorSetupRoute: ContributorSetupRoute,ContributorSubmitRoute: ContributorSubmitRoute,EmployeeResetPasswordRoute: EmployeeResetPasswordRoute,EmployeeSetupPasswordRoute: EmployeeSetupPasswordRoute,Job_categorySplatRoute: Job_categorySplatRoute,MemberResetPasswordRoute: MemberResetPasswordRoute,NewsletterSplatRoute: NewsletterSplatRoute,PartnerActivateRoute: PartnerActivateRoute,PartnerResetPasswordRoute: PartnerResetPasswordRoute,PartnerSetupRoute: PartnerSetupRoute,ProductsAgenticEnterprisePlatformRoute: ProductsAgenticEnterprisePlatformRoute,ProductsAkivaInceptionRoute: ProductsAkivaInceptionRoute,ProductsBiosRoute: ProductsBiosRoute,ProductsComputeRoute: ProductsComputeRoute,ProductsDatasyncEnterpriseRoute: ProductsDatasyncEnterpriseRoute,ProductsDecisionSupportRoute: ProductsDecisionSupportRoute,ProductsHardwareRoute: ProductsHardwareRoute,ProductsInceptionRoute: ProductsInceptionRoute,ProductsMarketinsightProRoute: ProductsMarketinsightProRoute,ProductsModelopsProRoute: ProductsModelopsProRoute,ProductsNovaEnterpriseRoute: ProductsNovaEnterpriseRoute,ProductsNovaHealthcareRoute: ProductsNovaHealthcareRoute,ProductsNovaWorkspaceRoute: ProductsNovaWorkspaceRoute,ProductsPerformancevisionProRoute: ProductsPerformancevisionProRoute,ProductsSmartsourceProRoute: ProductsSmartsourceProRoute,ProductsSoftwareRoute: ProductsSoftwareRoute,ServiceAiEngineeringRoute: ServiceAiEngineeringRoute,ServiceAiIntegrationRoute: ServiceAiIntegrationRoute,ServiceAiSecurityRoute: ServiceAiSecurityRoute,ServiceAiStrategyRoute: ServiceAiStrategyRoute,ServiceComputerVisionRoute: ServiceComputerVisionRoute,ServiceCybersecurityRoute: ServiceCybersecurityRoute,ServiceDataEngineeringRoute: ServiceDataEngineeringRoute,ServiceDigitalTransformationRoute: ServiceDigitalTransformationRoute,ServiceEnterpriseItRoute: ServiceEnterpriseItRoute,ServiceMlopsRoute: ServiceMlopsRoute,ServiceMultiAgentSystemsRoute: ServiceMultiAgentSystemsRoute,ServiceProgramManagementRoute: ServiceProgramManagementRoute,ServiceStrategyConsultingRoute: ServiceStrategyConsultingRoute,ServiceSupplyChainRoute: ServiceSupplyChainRoute,SurveyTokenRoute: SurveyTokenRoute,WpAdminSplatRoute: WpAdminSplatRoute,WpContentSplatRoute: WpContentSplatRoute,CareersIndexRoute: CareersIndexRoute,ProductsIndexRoute: ProductsIndexRoute,CareersResumeReuploadTokenRoute: CareersResumeReuploadTokenRoute,ClientInviteActivateRoute: ClientInviteActivateRoute,CompanyPressSplatRoute: CompanyPressSplatRoute,MemberInviteActivateRoute: MemberInviteActivateRoute,ProductsChatspaceSplatRoute: ProductsChatspaceSplatRoute,ProductsMindcruiserSplatRoute: ProductsMindcruiserSplatRoute,ProductsWebboardSplatRoute: ProductsWebboardSplatRoute,CareersJobsIndexRoute: CareersJobsIndexRoute,CompanyPressIndexRoute: CompanyPressIndexRoute,CareersJobsSlugApplyRoute: CareersJobsSlugApplyRoute,CareersJobsSlugIndexRoute: CareersJobsSlugIndexRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)